import { render, staticRenderFns } from "./PopupLoadForm2.vue?vue&type=template&id=2c66dfc8&scoped=true"
import script from "./PopupLoadForm2.vue?vue&type=script&lang=js"
export * from "./PopupLoadForm2.vue?vue&type=script&lang=js"
import style0 from "./PopupLoadForm2.vue?vue&type=style&index=0&id=2c66dfc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c66dfc8",
  null
  
)

export default component.exports